export const NAMESPACE = 'BASE_VIEWER/USERS/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_SHOW_AVATAR = NAMESPACE + 'SET_SHOW_AVATAR';
